import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    question: "Сколько времени занимает доставка автомобиля?",
    answer: "Сроки зависят от страны: Китай — 30-40 дней, Корея — 25-35 дней, США — 45-60 дней. Это включает покупку, доставку морем и растаможку.",
  },
  {
    question: "Какие гарантии вы предоставляете?",
    answer: "Мы предоставляем полный пакет документов на автомобиль, несём ответственность за сохранность при транспортировке и помогаем с гарантийными случаями от производителя.",
  },
  {
    question: "Как происходит оплата?",
    answer: "Оплата производится в несколько этапов: предоплата за автомобиль (обычно 10-30%), оплата остатка перед отправкой, и таможенные платежи по прибытии в РБ.",
  },
  {
    question: "Можно ли привезти электромобиль?",
    answer: "Да, электромобили сейчас особенно выгодны благодаря нулевой таможенной пошлине и НДС для авто младше 5 лет (Указ №92/428).",
  },
  {
    question: "Кто имеет право на льготу по Указу №140?",
    answer: "Физические лица, которые приобрели автомобиль более 6 месяцев назад и временно пребывали в иностранном государстве, могут получить скидку 50% на таможенную пошлину.",
  },
  {
    question: "Как узнать точную стоимость?",
    answer: "Воспользуйтесь нашим калькулятором на сайте или оставьте заявку — мы рассчитаем стоимость для конкретного автомобиля с учётом всех расходов.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section 
      id="faq" 
      className="py-24 bg-[#050505]"
      data-testid="faq-section"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <p className="text-white/40 text-xs uppercase tracking-[0.3em] mb-4">
            Вопросы
          </p>
          <h2 className="text-4xl md:text-5xl text-white font-normal">
            Частые вопросы
          </h2>
        </motion.div>

        {/* FAQ List */}
        <div className="space-y-0">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="border-t border-white/10 first:border-t-0"
              data-testid={`faq-${index}`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full py-6 flex items-center justify-between text-left group"
              >
                <span className="text-white text-base font-normal pr-8 group-hover:text-white/80 transition-colors">
                  {faq.question}
                </span>
                <ChevronDown 
                  className={`w-5 h-5 text-white/40 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                  strokeWidth={1}
                />
              </button>
              
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <p className="text-white/50 text-sm leading-relaxed pb-6">
                      {faq.answer}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
